import type { ExternalAccessId } from "@@/shared/acquire/access/external-access-id";
import type { ExternalAccessType } from "@@/shared/acquire/access/external-access";
import { now } from "@@/shared/date-time/date-time";
import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import type { TimeRange } from "@@/shared/date-time/time-range";
import type { LockyOrderData } from "@@/shared/orders/order-access/integration/locky-order-data";
import type { ProductId } from "@@/shared/products/product-id";
import type { CustomerId } from "@@/shared/users/customer-id";
import type { UserId } from "@@/shared/users/user-id";
import type { Except } from "type-fest";
import type { OrderId } from "../order-id";
import type { OrderExternalAccessId } from "./order-external-access-id";
import { orderExternalAccessIdFactory } from "./order-external-access-id";

type OrderExternalAccessData = LockyOrderData | undefined;

type OrderExternalAccess = {
    readonly _id: OrderExternalAccessId;
    readonly _type: "ORDER_EXTERNAL_ACCESS";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly accessId: ExternalAccessId;
    readonly accessType: ExternalAccessType;
    readonly productId?: ProductId;
    readonly orderId: OrderId;
    readonly validForUser: UserId | CustomerId;

    readonly accessName: string;
    readonly valid: TimeRange;
    readonly status: "ACTIVE" | "REVOKED";

    readonly data?: OrderExternalAccessData;
};

type FactoryParams = Except<
    OrderExternalAccess,
    "_type" | "_id" | "_createdAt"
>;
const orderAccessFactory = (params: FactoryParams): OrderExternalAccess => {
    return {
        _id: orderExternalAccessIdFactory(),
        _createdAt: now(),
        _type: "ORDER_EXTERNAL_ACCESS",
        ...params,
    };
};

export { orderAccessFactory };
export type { OrderExternalAccess };
